module.exports = __webpack_public_path__ + "img/plotting-save.de3eb2cb.svg";